import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-pictures2-icon',
  templateUrl: './files-pictures2.component.html'
})
export class FilesPictures2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
